import i18n from 'i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import availableLanguages from './components/common/availableLanguages.json';

i18n
  .use(LanguageDetector)
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    supportedLngs: availableLanguages.map((language) => language.code),
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'l',
      lookupLocalStorage: 'language',
      caches: ['localStorage'],
      convertDetectedLanguage: (l: string) => l.substring(0, 2), // en-US -> en
    },
    load: 'languageOnly',
    backend: {
      loadPath: (BASE || '/') + 'i18n/{{lng}}.json',
      requestOptions: { cache: 'no-cache' },
    },
    interpolation: {
      escapeValue: true,
    },
  })
  .catch(() => {
    console.error('Could not initialize i18n');
    // now what ?
  });

export default i18n;
